import React from "react"
import {
  Card,
  CardMedia,
  CardContent,
  Typography,
  useTheme,
  Box,
} from "@mui/material"
import { deepmerge } from "@mui/utils"

export const TransportationCard = ({
  title,
  image,
  icon: Icon,
  sx,
  ...props
}) => {
  const theme = useTheme()
  const styleOverrides =
    theme.components[`TransportationCard`]?.styleOverrides || {}
  const { root, cardMedia, cardIconWrapper, cardTitle, cardContent } =
    styleOverrides
  return (
    <Card sx={deepmerge(root, sx)} {...props}>
      <CardMedia component="img" src={image} sx={cardMedia} />
      <CardContent sx={cardContent}>
        {Icon && <Box sx={cardIconWrapper}>{Icon}</Box>}
        <Typography sx={cardTitle}>{title}</Typography>
      </CardContent>
    </Card>
  )
}
